import { render, staticRenderFns } from "./ValidationCodeModal.vue?vue&type=template&id=71ef38ee&scoped=true&"
import script from "./ValidationCodeModal.vue?vue&type=script&lang=js&"
export * from "./ValidationCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef38ee",
  null
  
)

export default component.exports